"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommissionSettlement = void 0;
var legacy_options_1 = require("@daytrip/legacy-options");
Object.defineProperty(exports, "CommissionSettlement", { enumerable: true, get: function () { return legacy_options_1.CommissionSettlement; } });
//# sourceMappingURL=host-agency-commission-settlement.model.js.map